import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function for conditionally joining class names with Tailwind CSS. This function combines clsx for
 * conditional class joining and tailwind-merge for deduplicating Tailwind CSS classes.
 *
 * @param inputs - Class values to be conditionally joined
 * @returns A string of merged and deduplicated class names
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
